import { FormProvider, useForm } from "react-hook-form";
import { MuniSpinner2, TextInput } from "../../../../../components";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { busquedaPatenteSchema } from "./schemas";
import { getDatosTitularPatente } from "./handlers";
import { Alert } from "@mui/material";

const FormConsultarDatosPatente = (props) => {
  const { setDatosTitular } = props;

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(busquedaPatenteSchema),
    defaultValues: {
      patente: "",
    },
  });

  return (
    <FormProvider {...methods}>
      <form
        className="position-relative d-flex flex-column gap-2 mt-3"
        // style={{ maxWidth: "320px" }}
        onSubmit={methods.handleSubmit((data) =>
          getDatosTitularPatente(data, setDatosTitular, methods.setError)
        )}
      >
        <fieldset className="d-flex flex-column align-items-center w-100  gap-1" disabled={methods.formState.isSubmitting}>
          {/* <Alert severity="info">Ingrese la patente para obtener los datos del infractor</Alert> */}
          <p className="m-0 font-bold text-primary">Ingrese la patente para obtener los datos del infractor</p>
          <div className="d-flex gap-2 align-items-start">
            <TextInput name="patente" 
            // label="Patente *" 
            />
            <Button type="submit" size="sm">
              {methods.formState.isSubmitting ? (
                <span className="d-flex justify-content-center gap-1">
                  <MuniSpinner2
                    width="18px"
                    height="18px"
                    circularProgressSize={24}
                    circularProgressColor="#ffffff"
                    fileName="bola-blanca.png"
                  />
                </span>
              ) : (
                "Consultar"
              )}
            </Button>
          </div>
        </fieldset>
      </form>
    </FormProvider>
  );
};

export default FormConsultarDatosPatente;
